// Port of SuiteModel/AgentDraft.swift: the metadata marker `agent-draft` on a document an agent made (MCP create_draft,
// create_structure) or filled (fill_empty_document) — one JSON string, keys sorted: at (ISO 8601, UTC, to the second),
// by (the client), filled (only when true), hash (SHA-256 hex of the text as drafted). The same bytes as the Swift's.
import { sha256Hex } from './hashing.ts';
import type { MetadataValue } from './contract.ts';

export interface AgentDraftRecord { by: string; at: Date; hash: string; filled: boolean }

export const AGENT_DRAFT_FIELD = 'agent-draft';

export const agentDraftHash = (text: string): string => sha256Hex(text);

/** The marker's value for a draft made now (`AgentDraft.marker`). */
export function agentDraftMarker(o: { by: string; at: Date; text: string; filled?: boolean }): string {
  const at = new Date(Math.floor(o.at.getTime() / 1000) * 1000).toISOString().replace('.000Z', 'Z');
  const object: Record<string, unknown> = { at, by: o.by };
  if (o.filled) object.filled = true;
  object.hash = agentDraftHash(o.text);
  return JSON.stringify(object);
}

/** `AgentDraft.record(from:)`: the marker read back, or null when there is none or it can't be read. */
export function readAgentDraft(metadata: Record<string, MetadataValue>): AgentDraftRecord | null {
  const v = metadata[AGENT_DRAFT_FIELD];
  if (v?.type !== 'text') return null;
  try {
    const o = JSON.parse(v.value) as Record<string, unknown>;
    if (typeof o.by !== 'string' || typeof o.at !== 'string' || typeof o.hash !== 'string') return null;
    const at = new Date(o.at);
    if (Number.isNaN(at.getTime())) return null;
    return { by: o.by, at, hash: o.hash, filled: o.filled === true };
  } catch {
    return null;
  }
}
